import { CSSProperties } from "react"
import { Mode } from "./ReadWriteTextField"

interface IProps {
  mode: Mode, 
  value: any,
  blankReadOnlyValue?: string,
  children: JSX.Element | JSX.Element[],
  style?: CSSProperties,
}

export function ReadWriteWrapper(props:IProps): JSX.Element {
  const spanStyle:CSSProperties|undefined = {position:"relative", width:"100%"} 
  if(props.mode !== "edit") {
    spanStyle.visibility = "hidden"
  }
  
  return <div style={{
    width:"100%", 
    position:"relative", 
    flexDirection:"column", 
    display:"flex", 
    justifyContent:"center", 
    ...props.style,
  }}
    >
    <div style={{
        width:"100%",
        position:"absolute", 
        left:0, 
        zIndex:props.mode !== "edit"?10:-10,
        visibility:props.mode !== "edit"?"visible":"hidden",
        overflow:"hidden",
        textOverflow:"ellipsis",
      }}
      title={props.value || props.blankReadOnlyValue || ""}
    >
      {props.value || props.blankReadOnlyValue || ""}
    </div>
    <span style={spanStyle}>
      {props.children}
    </span>
  </div>
}